import React, { FC, ReactNode } from "react";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeaderFilter from "./HeaderFilter";
import { useSearch } from "hooks/useFetch";
import ItemCard from "components/ItemCard/ItemCard";
import ItemCardLoading from "components/ItemCard/ItemCardLoading";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { useSelector } from "react-redux";
import { RootState } from "store";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: CarDataType[] = DEMO_CAR_LISTINGS.filter((_, i) => i < 8);

//
export interface SectionGridFeaturePlacesProps {
	stayListings?: CarDataType[];
	gridClass?: string;
	heading?: ReactNode;
	subHeading?: ReactNode;
	headingIsCenter?: boolean;
	tabs?: string[];
	query?: string;
}

const SectionGridFeatureRenty: FC<SectionGridFeaturePlacesProps> = ({
	stayListings = DEMO_DATA,
	gridClass = "",
	heading = "Barang sewa terbaru",
	subHeading = "Barang-barang sewa yang baru ada di Rentrips",
	headingIsCenter,
	tabs = ["Kuta", "Denpasar", "Canggu", "Sanur"],
	query = "",
}) => {
	const [data, loading] = useSearch(`${query}&limit=8`);
	const { userInfo } = useSelector((state: RootState) => state.userInfo);
	return (
		<div className="nc-SectionGridFeaturePlaces relative">
			<HeaderFilter
				subHeading={subHeading}
				tabs={tabs}
				heading={heading}
				onClickTab={() => {}}
				rent={true}
			/>

			{loading ? (
				<div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					{[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
						<ItemCardLoading key={item}></ItemCardLoading>
					))}
				</div>
			) : (
				<div
					className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
				>
					{
						data.map((item) => {
							return <ItemCard key={item._id} data={item} />;
						})}
				</div>
			)}

			<div className="flex mt-16 justify-center items-center">
				<ButtonPrimary
					href={`/listing?${query}`}
					onClick={() => {
						logging(userInfo?.token || "", {
							category: "product",
							action: "all",
						});
						eventAnalytic({
							category: "Product",
							action: "All Product",
						});
					}}
				>
					Cari lebih banyak barang
				</ButtonPrimary>
			</div>
		</div>
	);
};

export default SectionGridFeatureRenty;
